/**
 * Preset font family options offered in the HTML template style editor's
 * typography combobox. Custom values are still accepted by the form — these
 * are just the curated picks shown in the dropdown.
 */

export const FONT_FAMILY_COMBOBOX_OPTIONS = [
  { value: 'Arial, sans-serif', label: 'Arial' },
  { value: '"Arial Black", sans-serif', label: 'Arial Black' },
  { value: '"Book Antiqua", Palatino, serif', label: 'Book Antiqua' },
  { value: '"Baskerville BT", Baskerville, serif', label: 'Baskerville BT' },
  { value: 'Calibri, sans-serif', label: 'Calibri' },
  { value: 'Cambria, serif', label: 'Cambria' },
  { value: '"Charter ITC TT", Georgia, serif', label: 'Charter ITC TT' },
  { value: '"Courier New", Courier, monospace', label: 'Courier New' },
  { value: 'Garamond, serif', label: 'Garamond' },
  { value: 'Georgia, serif', label: 'Georgia' },
  { value: '"Helvetica Neue", Helvetica, sans-serif', label: 'Helvetica Neue' },
  { value: "'IBM Plex Sans', sans-serif", label: 'IBM Plex Sans' },
  { value: "'IBM Plex Serif', serif", label: 'IBM Plex Serif' },
  { value: "'Inter', sans-serif", label: 'Inter' },
  { value: "'Lato', sans-serif", label: 'Lato' },
  { value: "'Merriweather', serif", label: 'Merriweather' },
  { value: "'Montserrat', sans-serif", label: 'Montserrat' },
  { value: "'Noto Serif', serif", label: 'Noto Serif' },
  { value: "'Nunito', sans-serif", label: 'Nunito' },
  { value: "'Open Sans', sans-serif", label: 'Open Sans' },
  { value: "'Oswald', sans-serif", label: 'Oswald' },
  { value: 'Palatino, "Palatino Linotype", serif', label: 'Palatino' },
  { value: "'Playfair Display', serif", label: 'Playfair Display' },
  { value: "'Poppins', sans-serif", label: 'Poppins' },
  { value: "'PT Sans', sans-serif", label: 'PT Sans' },
  { value: "'PT Serif', serif", label: 'PT Serif' },
  { value: "'Raleway', sans-serif", label: 'Raleway' },
  { value: "'Roboto', sans-serif", label: 'Roboto' },
  { value: "'Source Sans Pro', sans-serif", label: 'Source Sans Pro' },
  { value: "'Source Serif Pro', serif", label: 'Source Serif Pro' },
  { value: 'Tahoma, sans-serif', label: 'Tahoma' },
  { value: '"Times New Roman", Times, serif', label: 'Times New Roman' },
  { value: '"Trebuchet MS", sans-serif', label: 'Trebuchet MS' },
  { value: 'Verdana, sans-serif', label: 'Verdana' }
] as const;

export type FontFamilyOption = (typeof FONT_FAMILY_COMBOBOX_OPTIONS)[number];
